import { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { SelectBox } from 'components';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ websitesData }) => ({
  websites: websitesData.websites.data,
  loadingWebsites: websitesData.websites.loading,
});

function WebsiteSelect({
  onChange,
  headTitle,
  value,
  disabled,
  //if true then the first website will initially be selected
  initSelectFirstWebsite,
  ...othersProps
}) {
  const { websites, loadingWebsites } = useSelector(mapState);
  const [websiteOptions, setWebsiteOptions] = useState([]);
  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  const SelectHeadTitle = headTitle || t('WEBSITE_SELECT_TITLE');

  const getWebsiteOptions = (websites) =>
    websites.map((item) => ({
      title: item.title,
      subTitle: item.url,
      value: item.id,
    }));

  useEffect(() => {
    if (!websites) return;

    const options = getWebsiteOptions(websites);

    setWebsiteOptions(options);
    if (initSelectFirstWebsite) {
      onChange(options[0]?.value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websites]);

  return (
    <SelectBox
      value={value}
      onChange={onChange}
      options={websiteOptions}
      title={SelectHeadTitle}
      loadingOptions={loadingWebsites}
      disabled={disabled}
      {...othersProps}
    />
  );
}

export default WebsiteSelect;
